import React, {
    useCallback,
    memo,
    Fragment,
    components,
    useState,
} from 'react';
import PropTypes from 'prop-types';

const TextInput = ({
    label,
    values,
    name,
    touched = {},
    errors = {},
    row,
    onChange,
    disabled,
    readOnly,
    type = 'text',
    placeHolder,
    buscador,
    classPlaceholder,
    onBlur,
}) => {
    const renderError = useCallback(
        () =>
            touched[name] &&
            errors[name] && <p className="c-error-message">*{errors[name]}</p>,
        [errors, name, touched]
    );

    const ViewTitle = () => {
        if (label === '') {
            return null;
        } else {
            return (
                <div className="c-accordion__header js-accordion__title c-vehicle-filters__item-title">
                    <span className="c-accordion__title"></span>
                    <h3 className="c-accordion__title">
                        <button
                            className="c-accordion__title-label js-accordion__title-label"
                            aria-expanded="true"
                            type="button"
                        >
                            <label
                                htmlFor={name}
                                className="c-accordion__title-label-text "
                            >
                                {label}
                            </label>
                        </button>
                    </h3>
                </div>
            );
        }
    };
    const iconSearch = () => {
        if (!buscador) return null;
        return (
            <i
                className="c-icon  c-icon--[semantic-search]"
                aria-hidden="true"
                role="img"
            />
        );
    };
    const onBlurInput = () => {
        if (onBlur) onBlur(values);
    };

    return (
        <Fragment>
            <ViewTitle />

            <div
                className="c-accordion__panel  js-accordion__panel c-ticket-filters__item-content"
                aria-hidden="false"
            >
                <div
                    className={
                        'c-accordion__content c-vehicle-filters__' + name
                    }
                >
                    <div className="c-input">
                        <input
                            className={'c-input__input ' + classPlaceholder}
                            id={name}
                            name={name}
                            value={values[name]}
                            type={type}
                            data-tr-component="Input Field"
                            data-tr-function="Text Input"
                            onChange={e => {
                                onChange(name, e.target.value);
                            }}
                            onBlur={onBlurInput}
                            disabled={disabled}
                            readOnly={readOnly}
                            placeholder={placeHolder}
                        />
                        <button
                            onClick={onBlurInput}
                            className="c-input__addon  c-input__addon--no-background"
                            aria-label="Toggle"
                            type="button"
                            data-toggle
                            style={{ paddingRight: 0 }} //ICON TO RIGHT, SAME SPACE AS CHEVRON FOR SELECTS
                        >
                            {iconSearch()}
                        </button>
                    </div>
                </div>
                {renderError()}
            </div>
        </Fragment>
    );
};

TextInput.propTypes = {
    row: PropTypes.any,
    disabled: PropTypes.any,
    readOnly: PropTypes.any,
    type: PropTypes.string,
    errors: PropTypes.object,
    touched: PropTypes.object,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    values: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    placeHolder: PropTypes.string,
    buscador: PropTypes.bool.isRequired,
    classPlaceholder: PropTypes.string,
};

export default memo(TextInput);
